<div>
    <a href="{{url}}" target="_blank" translate>home.openDataInfo</a>
</div>